import { createContext, useState } from 'react';

export const FaqSearchContext = createContext<{
  setSearchValue: (data: any) => void;
  searchValue: string;
  selectedCategory: any;
  setSelectedCategory: (category: any) => void;
  selectedTag: string;
  setSelectedTag: (string) => void;
}>(null);

export const FaqSearchProvider = ({ children }) => {
  const [searchValue, setSearchValue] = useState<string>('');
  const [selectedCategory, setSelectedCategory] = useState<any>(null);
  const [selectedTag, setSelectedTag] = useState<string>('');

  const _setSearchValue = (value: string) => {
    setSearchValue(value);
    setSelectedTag('');
    setSelectedCategory(null);
  };

  const _setSelectedTag = (tag: string) => {
    setSearchValue('');
    setSelectedTag(tag);
  };

  return (
    <FaqSearchContext.Provider
      value={{
        searchValue,
        setSearchValue: _setSearchValue,
        selectedCategory,
        setSelectedCategory,
        selectedTag,
        setSelectedTag: _setSelectedTag
      }}
    >
      {children}
    </FaqSearchContext.Provider>
  );
};
